import { DotsLoader, ScreenReaderOnly, ThemeProviderClean } from '@chilipiper/design-system'
import { parseQuery } from '@chilipiper/utils'
import { AvailabilityProvider } from '@chilipiper/booking-flow-legacy'
import { WaitingComponent as WaitingComponentLib } from '@chilipiper/meetings-components/src/waiting-component'
import { setSessionId } from '@chilipiper/service/src/session'
import isString from 'lodash/isString'
import React, { ComponentType, lazy, PropsWithChildren, useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { useFireRedirect } from 'app/guest-app/hooks/useFireRedirect'

const RouterGuestApp = lazy(() => import('./router-guest-app/RouterGuestApp'))
const CancelMeeting = lazy(() => import('./cancel-meeting/CancelMeeting'))
const Booking = lazy(() => import('./Booking'))
const NotFound = lazy(() => import('./NotFound'))

const WaitingComponent = (Component: ComponentType<any>) =>
  WaitingComponentLib(Component, <DotsLoader color='neutral-dark-32' height='100%' />)

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

export const GuestRouting = () => {
  // useLogRocket()
  useEffect(() => {
    // Adoption.init()
    // initTracking()
    const queryParams = parseQuery()
    if (isString(queryParams?.sessionId)) {
      setSessionId(queryParams.sessionId)
      // setTrackingUserId(getSessionId())
    }
  }, [])

  return (
    <ThemeProviderClean>
      <AvailabilityProvider>
        <QueryClientProvider client={client}>
          <Router>
            <GuestTracking />
            <Switch>
              <Route
                path='/router/:routerName'
                render={props => {
                  const Component = WaitingComponent(RouterGuestApp)
                  return (
                    <RedirectWrapper>
                      <Component {...props} />
                    </RedirectWrapper>
                  )
                }}
              />
              <Route path='/book/cancel/:reportId' component={WaitingComponent(CancelMeeting)} />
              <Route
                path='/book/*'
                render={props => {
                  const Component = WaitingComponent(Booking)
                  return (
                    <RedirectWrapper>
                      <Component {...props} />
                    </RedirectWrapper>
                  )
                }}
              />
              <Route path='/reschedule/*' component={WaitingComponent(Booking)} />
              <Route path='*' component={WaitingComponent(NotFound)} />
            </Switch>
          </Router>
        </QueryClientProvider>
      </AvailabilityProvider>
    </ThemeProviderClean>
  )
}

const RedirectWrapper = ({ children }: PropsWithChildren) => {
  const { isLoading } = useFireRedirect()

  if (isLoading) {
    return (
      <ThemeProviderClean>
        <ScreenReaderOnly role='status'>Loading Page</ScreenReaderOnly>
        <DotsLoader color='neutral-dark-32' height='100%' />
      </ThemeProviderClean>
    )
  }
  return children
}

const GuestTracking = () => {
  //const location = useLocation()
  //useEffect(() => {
  //  trackPageView()
  //}, [location])
  return null
}
